import { createRoot } from "react-dom/client";

import { YakTrails } from "./YakTrails";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Yak Trails root element is missing");

document.documentElement.style.height = "100%";
document.body.style.height = "100%";
document.body.style.margin = "0";
root.style.width = "100%";
root.style.height = "100%";
root.style.overflow = "hidden";

const initialPartySlug = window.location.hash.match(/^#\/yak-trails\/party\/([a-z0-9-]+)$/i)?.[1];
const initialTournamentId = window.location.hash.match(/^#\/yak-trails\/tournament\/([a-z0-9_-]+)$/i)?.[1];
const initialAdminScreen = window.location.hash === "#/yak-trails/admin";

createRoot(root).render(<YakTrails
  initialPartySlug={initialPartySlug}
  initialTournamentId={initialTournamentId}
  initialAdminScreen={initialAdminScreen}
/>);
